import { render, staticRenderFns } from "./SubtaskStateChangeForm.vue?vue&type=template&id=8d8ba8ac"
import script from "./SubtaskStateChangeForm.vue?vue&type=script&lang=js"
export * from "./SubtaskStateChangeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports